<template>
  <customize-header class="page-my-medal">
    <template #header>
      <top-bar show-header
               header-plain
               back-color="#fff"
      />
    </template>
    <div v-if="user"
         class="page-header"
    >
      <ym-avatar class="user-avatar"
                 size="medium"
                 :avatar="user.avatar"
                 :name="user.name"
      />
      <div class="info">
        <span class="name">{{ user.name }}</span>
        <span v-if="count > 0"
              class="count"
        >已获得{{ count }} 枚勋章</span>
      </div>
    </div>
    <ym-loadmore v-if="list.length > 0"
                 class="medal-list"
                 v-model="loading"
                 :finished="allLoad"
                 @load="fetchData"
    >
    <div class="medal-block"
           v-for="(item, index) in list"
           :key="index"
      >
        <div class="date-block">
          <div class="year"
               :class="{ 'hidden': item.hideYear }"
          >
            {{ item.receiveTime|formatTime('yyyy') }}年
          </div>
          <div class="month-day-block">
            <span class="day">{{ item.receiveTime|formatTime('dd') }}</span>
            <span class="month">{{ item.receiveTime|formatTime('MM') }}月</span>
          </div>
        </div>
        <div class="medal-item"
             v-for="(medalItem, medalIndex) in item.data"
             :key="medalIndex"
        >
          <template v-if="medalItem.medal.type === 'normal'">
            <div class="cover">
              <ym-img class="medal-cover"
                      :src="medalItem.medal.src"
                      alt="勋章图片"
                      @click="handleMedalClick(medalItem.medal)"
              />
            </div>
            <div class="medal-info">
              <span class="about"
                    v-html="medalItem.task.about"
              ></span>
            </div>
          </template>
          <template v-if="medalItem.medal.type === 'challenge'">
            <div class="cover">
              <ym-img class="medal-cover"
                      :src="medalItem.medal.src"
                      alt="勋章图片"
                      @click="handleMedalClick(medalItem.medal)"
              />
            </div>
            <div class="medal-info"
                 @click="handleWorkDetail(medalItem.work.id)"
            >
              <span class="about"
                    v-html="medalItem.task.about"
              ></span>
              <span class="work-detail">查看作品</span>
            </div>
          </template>
          <template v-if="medalItem.medal.type === 'course'">
            <div class="cover">
              <ym-img class="medal-cover course"
                      :src="medalItem.medal.src"
                      alt="勋章图片"
                      @click="handleMedalClick(medalItem.medal)"
              />
            </div>
            <div class="medal-info">
              <span class="about"
                    v-html="medalItem.task.about"
              ></span>
            </div>
          </template>
        </div>
      </div>
      <medal-popup :show.sync="showPopup"
                   :title="medalTitle"
                   :src="medalUrl"
                   :desc="medalDesc"
      />
    </ym-loadmore>
    <div v-if="allLoad && list.length === 0"
         class="empty"
    >
      <empty-page hint="你还没有相关勋章哦～" />
    </div>
  </customize-header>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import CustomizeHeader from '@/layout/CustomizeHeaderLayout';
  import TopBar from '@/components/TopBar';
  import MedalPopup from '@/components/MedalPopup';
  import Avatar from '@/components/Avatar';
  import { getMyMedalData } from '@/services/user';
  import { LIMIT } from '@/utils/constant';
  import { formatYear } from '@/utils/index';
  import EmptyPage from '@/components/EmptyPage';

  export default {
    name: 'PageMyMedal',
    metaInfo: {},
    components: {
      'ym-loadmore': Loadmore,
      CustomizeHeader,
      TopBar,
      MedalPopup,
      'ym-avatar': Avatar,
      EmptyPage,
    },
    data() {
      return {
        start: 0,
        count: 0,
        list: [],
        user: null,
        showPopup: false,
        medalTitle: '',
        medalUrl: '',
        medalDesc: '',
        loading: false,
        allLoad: false,
      };
    },
    methods: {
      async fetchData(isLoadMore = true) {
        if (this.allLoad) return;
        this.loading = true;

        const data = await getMyMedalData({
          limit: LIMIT,
          start: this.start,
        }, isLoadMore);
        this.loading = false;
        this.list = formatYear([...this.list, ...data.list], 'receiveTime');
        this.user = data.user;
        this.count = data.count;
        this.start = data.start;
        if (data.list.length === 0) {
          this.allLoad = true;
        }
      },
      handleCourseDetail(id) {
        this.$router.push({ name: 'CourseDetail', params: { id } });
      },
      handleMedalClick(medal) {
        this.medalTitle = medal.title;
        this.medalUrl = medal.src;
        this.medalDesc = medal.desc;
        this.showPopup = true;
      },
      handleWorkDetail(id) {
        this.$router.push({ name: 'WorkDetail', params: { id } });
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>


<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-my-medal {
    min-height: 100%;
    background: @color-white;

    /deep/ .container {
      margin-top: -@header-height;
    }
  }

  .page-header {
    position: relative;
    width: 100%;
    height: 318px;
    padding: 0 0 @size-large @size-large;
    box-sizing: border-box;
    display: flex;
    align-items: flex-end;
    background-image: url('@{assets-img}certificate/certificate_header.png');
    background-size: 100% 318px;
  }

  .info {
    height: 100px;
    margin-left: @size-base;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: @color-white;
    font-size: @font-size-base;
    line-height: 1;
  }

  .name {
    font-weight: @font-weight-primary;
    font-size: @font-size-large;
    line-height: 1;
  }

  .count {
    margin-top: @size-small;
  }

  .date-block {
    margin-top: @size-large;
    margin-bottom: @size-medium;
    .year {
      margin-bottom: @size-extra-medium;
      font-size: @font-size-extra-large;
      line-height: 1;
      color: @color-text-base;
      &.hidden {
        display: none;
      }
    }
    .month-day-block {
      display: flex;
      align-items: flex-end;
      font-weight: @font-weight-primary;
      color: @color-text-base;
      .day {
        margin-right: @size-small;
        font-size: @font-size-largest;
        line-height: 1;
      }
      .month {
        font-size: @font-size-base;
      }
    }
  }

  .medal-list {
    padding: 0 @size-base @size-large;
  }

  .medal-item {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    &:not(:last-child) {
      margin-bottom: @size-large;
    }
  }

  @medal-cover-width: 120px;
  .cover {
    flex-shrink: 0;
    width: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .medal-cover {
    width: @medal-cover-width;
    &.course {
      width: 150px;
    }
  }

  .medal-info {
    width: 510px;
    padding: @size-base;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    background: @background-color-lighter;
    border-radius: @border-radius-base;
    .about {
      font-size: @font-size-base;
      font-weight: @font-weight-primary;
      color: @color-text-base;
      line-height: 1.4;
      /deep/ p {
        margin: 0;
        padding: 0;
      }
    }
    .work-detail {
      align-self: flex-end;
      margin-top: @size-small;
      padding: @size-extra-small @size-small;
      font-size: @font-size-base;
      line-height: 1;
      background: @color-primary-lighter;
      border-radius: @border-radius-base;
      color: @color-primary;
    }
  }
</style>
